import { render } from "./ModalPopUp.vue?vue&type=template&id=16628368"
import script from "./ModalPopUp.vue?vue&type=script&lang=js"
export * from "./ModalPopUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Special/ModalPopUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16628368"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16628368', __exports__)) {
    api.reload('16628368', __exports__)
  }
  
  module.hot.accept("./ModalPopUp.vue?vue&type=template&id=16628368", () => {
    api.rerender('16628368', render)
  })

}


export default __exports__